// src/pages/EditEventPage.js
import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import localPngImage from 'assets/images/PowerBySijil.png'; 

// Soft UI Dashboard React components
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiBox from "components/SuiBox";

// MUI components
import Grid from "@mui/material/Grid";
import Modal from '@mui/material/Modal';
import Icon from "@mui/material/Icon";

// Libraries and helpers
import { useSnackbar } from "notistack";
import { Auth } from "aws-amplify";
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import { FileUploader } from "react-drag-drop-files";
import { degrees, PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import Draggable from 'react-draggable';
import axios from "axios";

// Custom components and layout
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Table from "layouts/event/components/Table";

// Additional styles
import 'layouts/event/index.css';
import 'tui-image-editor/dist/tui-image-editor.css';

const EditEventPage = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [eventData, setEventData] = useState(null);
  //const [eventName, setEventName] = useState("")
  const [Filename,setFilename] = useState()
  const [initialFilename, setInitialFilename] = useState(); // State for initial FileUploader
  const [modalFilename, setModalFilename] = useState(); // State for modal FileUploader
  const [rows,setRows] = useState([])
  const [date1,setdate] = useState(new Date().getDate())
  const [name,setname] = useState("")
  const [reglink, setreglink] = useState("")
  const [x, setX] = useState(0)
  const [y, setY] = useState(0)
  // const [name, setName] = useState("test")
  const [cat, setcat] = useState("")
  const [R, setR] = useState(0)
  const [G, setG] = useState(0)
  const [B, setB] = useState(0)
  const [size, setSize] = useState(30)
  const [pdfinfo, setPdfInfo] = useState()
  const [load,setLoad] = useState(false)
  const iframeRef = useRef(null);
  const iframeRefEdit = useRef(null);
  const [pdfDimensions, setPdfDimensions] = useState({ width: 600, height: 800 });
  const { enqueueSnackbar } = useSnackbar();
  const [loc,setloc] = useState("")
  const [tenant,setTenant] = useState("")
  const [catError, setCatError] = useState(false);
  const [eventName1, setEventName1] = useState('');
  const [eventDate, setEventDate] = useState('');
  const [eventLocation, setEventLocation] = useState('');
  const [eventLink, setEventLink] = useState('');
  const location = useLocation();
  const { eventName } = location.state || {};
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [CurrentCertID,setCurrentCertID] = useState('');
  const [currentCat, setCurrentCat] = useState('');
  const [currentFilename,setCurrentFilename] = useState('');
  const [currentFontsize,setCurrentFont] = useState('');
  const [currentX, setCurrentX] = useState(0)
  const [currentY, setCurrentY] = useState(0)
  const [serialX, setSerialX] = useState(150);
  const [serialY, setSerialY] = useState(100);
  const [currentSerialX, setCurrentSerialX] = useState(150);
  const [currentSerialY, setCurrentSerialY] = useState(100);
  const [serialSize, setSerialSize] = useState(12);
  const [currentSerialSize, setCurrentSerialSize] = useState("");
  const [EditFilename,setEditFilename] =useState("");
  const [editpdfDimensions, setEditPdfDimensions] = useState({ width: 600, height: 800 });
  const [Editpdfinfo, setEditPdfInfo] = useState()
  const [customCat, setCustomCat] = useState('');
  const [subscriptionPlan, setSubPlan] = useState('');



  
  useEffect(() => {
    // Fetch event data when component mounts
    fetchEvent(eventId);  
  }, [eventId]);

  useEffect(() => {
    // Fetch event rows when component mounts
    row(eventId);
  }, [eventId]); // Only run once on component mount

  useEffect(() => {
    // Modify PDF when Filename, x, y, R, G, B, or size changes
    if (initialFilename) {
      modifyPdf(initialFilename);
    }
  }, [initialFilename, x, y, R, G, B, size]);

  useEffect(() => {
    // Modify PDF when Filename, x, y, R, G, B, or size changes
    if (modalFilename) {
      modifyCurrentPdf(modalFilename);
    }
  }, [modalFilename, currentX, currentY, R, G, B, currentFontsize]);

  useEffect(() => {
    // Fetch current user info to determine tenant
    Auth.currentUserInfo().then(value => {
      if (value.username === 'admin') {
        setTenant("admin");
      } else {
        setTenant(value.attributes["custom:company"]);
        setSubPlan("basic")
      }
    });
  }, []);

  //console.log("Tenant:"+tenant)

  const handleInitialFileChange = async (file) => {
    setInitialFilename(file.name);
    uploadFile(file); // Upload to S3

    const url = URL.createObjectURL(file);
    const pdf = await pdfjsLib.getDocument(url).promise;
    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: 1 });

    setPdfDimensions({ width: viewport.width, height: viewport.height });
  };

  const handleModalFileChange = async (file) => {
    setModalFilename(file.name);
    uploadCurrentFile(file); // Upload to S3

    const url = URL.createObjectURL(file);
    const pdf = await pdfjsLib.getDocument(url).promise;
    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: 1 });

    setPdfDimensions({ width: viewport.width, height: viewport.height });
  };

  const certColumns = [
    { name: "Name", align: "left" },
    { name: "Category", align: "left" },
    { name: "Edit", align: "center" },
    { name: "Delete", align: "center" },
  ];

  const dropdownOptions = [
    { value: 'Winner', label: 'Winner' },
    { value: 'Runner-Up', label: 'Runner-Up' },
    { value: 'Second Runner-Up', label: 'Second Runner-Up' },
    { value: 'Participant', label: 'Participant' },
    { value: 'Finalist', label: 'Finalist' },
    { value: 'Training', label: 'Training' },
    { value: 'Advisor', label: 'Advisor' },
  ];

  const fetchEvent = async (eventId) => {
    try {
        const response = await axios.get("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/getEvents");
        const eventList = response.data;
        const eventData = eventList.find(event => event.id === eventId);

        if (eventData) {
            setEventName1(eventData.name);
            setEventDate(eventData.date);
            setEventLocation(eventData.location)
            setEventLink(eventData.link)
          } else {
            console.log(`Event with ID ${eventId} not found`);
          }    
      } catch (error) {
        console.error('Error fetching events:', error);
      }
  };

  const fetchCert = async (certId) => {
    console.log("Current cert:" + certId)
    try {
        const response = await axios.post("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/getCert2", {
            event:eventId,
            tenant:tenant
        });

        console.log(response)
        const currentCert = response.data.find(cert => cert.id === certId );

        setCurrentX(parseInt(currentCert.x,10));
        setCurrentY(parseInt(currentCert.y,10));
        handleCategoryChange(currentCert.Category);
        setCurrentFilename(currentCert.filename);
        setCurrentFont(currentCert.fontsize);
        setCurrentSerialX(currentCert.serialX);
        setCurrentSerialY(currentCert.serialY);
        setCurrentSerialSize(currentCert.serialsize)

      } catch (error) {
        console.error('Error fetching events:', error);
      }
  };

  const categoryCodes = {
    winner: "A",
    "winner 1": "A",
    "runner-up": "B",
    "winner 2": "B",
    "second runner-up": "D",
    "winner 3": "D",
    participant: "E",
    finalist: "F",
    training: "G",
    advisor: "H"
  };

  let unlistedCategoryCounter = 1;
  const unlistedCategoryCodes = {};

  const getCategoryCode = (category) => {
    const normalizedCategory = category.toLowerCase().replace(/\s+/g, '-');
    if (categoryCodes[normalizedCategory]) {
      return categoryCodes[normalizedCategory];
    } else if (unlistedCategoryCodes[normalizedCategory]) {
      return unlistedCategoryCodes[normalizedCategory];
    } else {
      const newCode = `C${unlistedCategoryCounter}`;
      unlistedCategoryCodes[normalizedCategory] = newCode;
      unlistedCategoryCounter++;
      return newCode;
    }
  };
  const row = async () => {
    try {
        const response = await axios.post("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/getCert2", {
          event:eventId, 
          tenant: tenant
        });
        const certificates = response.data;

        console.log(certificates)

        const rows1 = certificates.map(cert => ({
          Name: cert.filename,
          // Category: cert.Category,
          Category: `${cert.Category} - ${getCategoryCode(cert.Category)}`,
          Edit: <SuiButton variant="text" color="success" size="medium" onClick={() => {setIsModalOpen(true);editCertificate(cert.filename,cert.id,tenant)}}><Icon sx={{ fontWeight: "bold"}}>edit</Icon></SuiButton>,
          // Edit: <SuiButton variant="outlined" color="info" size="small" onClick={() => enqueueSnackbar("This function still in developement", { variant: 'alert' })}>Edit</SuiButton>,
          Delete: <SuiButton variant="text" color="error" size="medium" onClick={() => deleteCert(cert.id)}><Icon sx={{ fontWeight: "bold"}}>delete</Icon></SuiButton>
        }));
    
        setRows(rows1);
      } catch (error) {
        console.error("Error fetching certificates:", error);
      }
  };

  const editCertificate = async (fileName, certId) => {
    try {
      const userInfo = await Auth.currentUserInfo();
      if (userInfo.username === 'admin') {
        setTenant("admin");
      } else {
        setTenant(userInfo.attributes["custom:company"]);
      }
  
      // Ensure tenant is set before proceeding
      const tenantValue = userInfo.username === 'admin' ? 'admin' : userInfo.attributes["custom:company"];
  
      console.log(tenantValue);
      setCurrentCertID(certId);
      fetchCert(certId);
  
      // Fetch PDF content and update state
      const response = await fetch(`https://certificatesys.s3.ap-southeast-1.amazonaws.com/${tenantValue}/${eventId}/${fileName}`);
      const existingPdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      const { width, height } = firstPage.getSize();
      const pdfBytes = await pdfDoc.save();
      const bytes = new Uint8Array(pdfBytes);
      const blob = new Blob([bytes], { type: "application/pdf" });
      const docUrl = URL.createObjectURL(blob);
  
      // Update state variables for editing modal
      setEditPdfInfo(docUrl); // Update the PDF URL
      setEditPdfDimensions({ width, height }); // Update dimensions if needed
      setEditFilename(fileName); // Set the filename for future modifications
    } catch (error) {
      console.error("Error loading PDF:", error);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  
  const deleteCert = async (certname) => {
    try {
      // Check if the CSV file exists in S3
      const response = await fetch(`https://certificatesys.s3.ap-southeast-1.amazonaws.com/${eventId}.csv`);
      if (response.ok) {
        // CSV file exists
        enqueueSnackbar('This certificate cannot be deleted', {
          variant: 'warning',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center'
          }
        })
      } else if (response.status === 403) {
        console.log(certname)
        // CSV file does not exist, proceed with deletion
        await axios.post("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/removeCert", { id: certname });
        enqueueSnackbar('Certificate has been deleted', {
          variant: 'success',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center'
          }
        })
        row(); // Refresh rows after deletion
      } else {
        console.error("Error checking CSV file:", response.statusText);
      }
    } catch (error) {
      console.error("Error during the deleteCert process:", error);
    }
  };

  const modifyPdf = async (file) => {
    try {
      // Fetch the existing PDF
      const existingPdfBytes = await fetch(
        `https://certificatesys.s3.ap-southeast-1.amazonaws.com/${tenant}/${eventId}/${file}`
      ).then((res) => res.arrayBuffer());
  
      // Load the PDF document
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
  
      // Embed the Helvetica font
      const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
  
      // Load the local PNG image
      const pngImageBytes = await fetch(localPngImage).then((res) => res.arrayBuffer());
      const pngImage = await pdfDoc.embedPng(pngImageBytes);
      console.log (pngImage)
      // Get the first page of the PDF
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      const { width, height } = firstPage.getSize();
  
      // Draw the PNG image on the first page
      const pngDims = pngImage.scale(0.5); // Scale the image (adjust as needed)
      firstPage.drawImage(pngImage, {
        x: width/2.5, // X-coordinate (adjust as needed)
        y: height-(height- 20), // Y-coordinate (adjust as needed)
        width: pngDims.width,
        height: pngDims.height,
      });
  
      // Save the modified PDF
      const pdfBytes = await pdfDoc.save();
      const bytes = new Uint8Array(pdfBytes);
      const blob = new Blob([bytes], { type: 'application/pdf' });
      const docUrl = URL.createObjectURL(blob);
  
      // Update state with the modified PDF URL and dimensions
      setPdfInfo(docUrl);
      setPdfDimensions({ width, height });
    } catch (error) {
      console.error('Error modifying PDF:', error);
    }
  };
  

  const modifyCurrentPdf = async (file) => {
    try {
      const existingPdfBytes = await fetch(`https://certificatesys.s3.ap-southeast-1.amazonaws.com/${file}`).then(res => res.arrayBuffer());
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      const { width, height } = firstPage.getSize();
    // Calculate the width of the text
    const textWidth = helveticaFont.widthOfTextAtSize("[Sample Text]", parseInt(size));

    // Calculate the x-coordinate to center the text
    const centerX = (width - textWidth) / 2;

  
      // firstPage.drawText("[Sample Text]", {
      //   x: centerX-9,
      //   y: height - parseInt(currentY) + 23,
      //   size: parseInt(size),
      //   font: helveticaFont,
      //   color: rgb(parseFloat(R), parseFloat(G), parseFloat(B)),
      // });
      
      const pdfBytes = await pdfDoc.save();
      const bytes = new Uint8Array(pdfBytes);
      const blob = new Blob([bytes], { type: "application/pdf" });
      const docUrl = URL.createObjectURL(blob);
      setPdfInfo(docUrl);
      setPdfDimensions({ width, height });
    } catch (error) {
      console.error("Error modifying PDF:", error);
    }
  };

  async function uploadFile(file) {
      
    setLoad(true)

    await  axios.get(`https://hlsw9m3hud.execute-api.ap-southeast-1.amazonaws.com/default/uploadfile?filename=${file.name}&bucket=certificatesys&event=${eventId}&tenant=${tenant}&typeupload=file`).then(async (value)=>{
            //Create the FormData
            //Send the file to File-system
      console.log("Sending file to S3...");
      await axios.put(value.data, file, {    
        headers: {
            'Content-Type': 'application/pdf',
        } 
      }).then( value => {
        enqueueSnackbar('Your credential is ready', {
          variant: 'info',
        })
        setLoad(false)
        modifyPdf(file.name)
        setX(0)
        setY(0)
      }).catch (error=> {
        console.log(error)
      })  
}).catch(error =>{
  console.log(error)
})       
}

  const uploadCurrentFile = async (file) => {
    // Upload file to S3 and modify PDF
    setLoad(true);
    try {
      const response = await axios.get(`https://hlsw9m3hud.execute-api.ap-southeast-1.amazonaws.com/default/uploadfile?filename=${file.name}&bucket=certificatesys&event=${eventName}&tenant=${tenant}`); 
      // Use response.data as the presigned URL
      await axios.put(response.data, file, {
        headers: {
          'Content-Type': 'application/pdf',
        }
      });
      setLoad(false);
      modifyCurrentPdf(file.name);
      setCurrentX(0);
      setCurrentY(0);
    } catch (error) {
      console.error("Error uploading file:", error);
      setLoad(false);
    }
  };

  const createcertdetails = async () => {
    console.log(eventName);
    console.log(initialFilename);
    console.log(serialSize);
  
    // Create certificate details logic
    if (!cat) {
      setCatError(true);
      enqueueSnackbar('Please select a category', { variant: 'error' });
    } else {
      setCatError(false);
      try {
        const categoryToSend = cat === 'custom' ? customCat : cat;
  
        await axios.get(`https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/AddCert?filename=${initialFilename}&cat=${categoryToSend}&x=${x}&y=${y}&fontsize=${size}&eventname=${eventName}&eventId=${eventId}&serialX=${serialX}&serialY=${serialY}&serialsize=${serialSize}`);
  
        enqueueSnackbar("Certificate Added", { variant: 'success' });
        row();
        setPdfInfo(null);
        setCurrentCat("");
        setcat(""); // Reset currentCat after successful submission
        setCustomCat(""); // Reset customCat after successful submission
        setSize(20);
        setR(0);
        setG(0);
        setB(0);
        setSerialX(150);
        setSerialY(100);
        setSerialSize(0)
      } catch (error) {
        console.error(error);
        enqueueSnackbar("Failed to add certificate", { variant: 'error' });
      }
    }
  };

  const updateCertDetails = async (CurrentCertID) => {
    try {
      console.log("Edited Certificate ID:", CurrentCertID);
      console.log("Filename:", currentFilename);
      console.log("Category:", currentCat);
      console.log("X:", currentX);
      console.log("Y:", currentY);
      console.log("Event:", eventName);
      console.log("Fontsize:", currentFontsize);
  
      const categoryToSend = currentCat === 'custom' ? customCat : currentCat;
  
      const requestBody = {
        id: CurrentCertID,
        filename: currentFilename,
        cat: categoryToSend, // Use categoryToSend instead of currentCat directly
        x: currentX,
        y: currentY,
        fontsize: currentFontsize,
        eventname: eventName,
        serialX: currentSerialX,
        serialY: currentSerialY,
        serialsize : currentSerialSize
      };
  
      const requestData = {
        body: JSON.stringify(requestBody)
      };
  
      console.log("Request Data:", JSON.stringify(requestData));
  
      const response = await axios.post(
        'https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/updateCert',
        JSON.stringify(requestData),
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
  
      if (response.data) {
        console.log('Certificate Updated:', response.data);
        enqueueSnackbar("Certificate Updated", { variant: 'success' });
      } else {
        console.error('Error updating certificate: Empty response');
        enqueueSnackbar("Error updating certificate", { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating certificate:', error);
      enqueueSnackbar("Error updating certificate", { variant: 'error' });
    }
  };
  
  const handleStop = (e, data) => {
    setX(data.x);
    setY(data.y);
    console.log(`Text field moved to x: ${data.x}, y: ${data.y}`);
  };

  const handleStopModal = (e, data) => {
    setCurrentX(data.x);
    setCurrentY(data.y);
    console.log(`Text field moved to x: ${data.x}, y: ${data.y}`);
  };

  const handleSave = () => {
    // Save event data logic
    console.log('Event saved:', eventData);
    navigate('/events'); // Redirect after saving
  };

  const handleCurrentCat = (e) => {
    const value = e.target.value;
    setCurrentCat(value);
    if (value === 'custom') {
      setCustomCat(''); // Reset custom category input if 'custom' is selected
    }
    setCatError(false);
  };

  const handleCat = (e) => {
    const value = e.target.value;
    setcat(value);
    if (value === 'custom') {
      setCustomCat(''); // Reset custom category input if 'custom' is selected
    }
    setCatError(false);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setCustomCat(value);
    setCurrentCat('custom');
  };

  const handleCategoryChange = (value) => {
    const isDropdownOption = dropdownOptions.some(option => option.value === value);

    if (isDropdownOption) {
      setCurrentCat(value);
    } else {
      setCurrentCat("custom");
      setCustomCat(value);
    }
    
  };

  const fontSizes = [8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30];
  const serialFontSizes = [8,10,12,14];

  return (
    <DashboardLayout>
      <DashboardNavbar eventName= {eventName}/>
      <SuiBox mt={1} mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={3}>
              <SuiBox 
                  p={2} 
                  bgColor={"white"}                   
                  borderRadius="xl" 
                  display="flex"
                  flexDirection="column"  
                  >
              <SuiTypography component="label" fontWeight="bold">
                        Event Details
                      </SuiTypography>
                      <SuiBox mb={2}>
                        <SuiBox mb={1} ml={0.5}>
                          <SuiTypography component="label" variant="caption" fontWeight="bold">
                            Event Name
                          </SuiTypography>
                        </SuiBox>
                        <SuiInput type="text" placeholder="Name" value={eventName1} onChange={(e)=>{setname(e.target.value)}} readOnly/>

                        <SuiBox mb={1} ml={0.5}>
                          <SuiTypography component="label" variant="caption" fontWeight="bold">
                            Event Location
                          </SuiTypography>
                        </SuiBox>
                        <SuiInput type="text" placeholder="Location" value={eventLocation} onChange={(e)=>{setloc(e.target.value)}} readOnly/>

                        <SuiBox mb={1} ml={0.5}>
                          <SuiTypography component="label" variant="caption" fontWeight="bold">
                            Event Website
                          </SuiTypography>
                        </SuiBox>
                        <SuiInput type="text" placeholder="Link" value={eventLink} onChange={(e)=>{setreglink(e.target.value)}} readOnly/>

                        <SuiBox mb={1} ml={0.5}>
                          <SuiTypography component="label" variant="caption" fontWeight="bold">
                            Event Date
                          </SuiTypography>
                        </SuiBox>
                        <SuiInput type="date" placeholder="Date" value={eventDate} onChange={(e)=>{setdate(e.target.value)}} readOnly/>
                      </SuiBox>
                      {/* <SuiBox mt={4} mb={1} align="center">
                        <SuiButton
                          color="dark"
                          variant="gradient"
                          //onClick={() => setUploadCert(!uploadCert)}
                          onClick={() => (console.log("klik"))}
                        >
                          Save Event
                        </SuiButton>
                      </SuiBox> */}
              </SuiBox>    
            </Grid>
          <Grid item xs={12} lg={9} sx={{ display: "flex", flexDirection: "column" }}>
          <SuiBox
            p={2}
            bgColor={"white"}
            borderRadius="xl"
            sx={{ flex: 1, display: "flex", flexDirection: "column" }}
          >
            <SuiBox>
            <SuiTypography component="label" fontWeight="bold">
                        Certificate Lists
                      </SuiTypography>
                <SuiButton onClick={row} style={{float:"right"}} variant="gradient" color="dark">                    
                        <Icon sx={{ fontWeight: "bold" }}>refresh</Icon>
                        </SuiButton>
            </SuiBox>   
                        {/* <Table
                          columns={columns} 
                          rows={rows} /> */}
                  {rows.length === 0 ? ( // Conditionally render the message when rows array is empty
                    <SuiBox>
                      <SuiTypography variant="h5" color="secondary" textAlign="center" mt={2}>
                      There are no certificates for this event yet.
                      </SuiTypography>
                    </SuiBox>   
                    ) : (
                      <SuiBox
                        sx={{
                          "& .MuiTable-root": {
                            boxShadow: "none",
                            backgroundColor: "#fff", // Example background color for the table
                          },
                          "& .MuiTableCell-root": {
                            padding: "16px", // Example padding for the table cells
                            fontSize: "14px", // Example font size for the table cells
                          },
                          "& .MuiTableRow-root": {
                            "&:hover": {
                              backgroundColor: "#fff", // Example hover effect for table rows
                            },
                          },
                          "& .MuiTableHead-root": {
                            "& .MuiTableCell-root": {
                              fontWeight: "bold", // Example font weight for the table header cells
                              backgroundColor: "#fff", // Example background color for the table header cells
                            },
                          },
                        }}
                      >
                        <Table columns={certColumns} rows={rows} />
                      </SuiBox>
                    )}
              </SuiBox> 
            </Grid>
          </Grid>
      </SuiBox>
      <SuiBox mt={3} mb={3} bgColor={"white"} borderRadius="xl">
        <Grid container>
          <Grid item xs={12} lg={3}>
            <SuiBox p={2} pr={4}>
              <SuiBox mt={0} mb={0}>
                <h4>Certificate Details</h4>
              </SuiBox>
              <SuiTypography component="label" variant="caption" fontWeight="bold">
                Certificate Template
              </SuiTypography>
              <FileUploader className="file-uploader" handleChange={handleInitialFileChange} types={['pdf']} />
              <SuiTypography component="label" variant="caption" fontWeight="bold">
                Certificate Category
              </SuiTypography>
              <SuiBox>
                {/* <select
                  className="dropdownInputField"
                  value={cat}
                  onChange={(e) => { setcat(e.target.value); setCatError(false); }}
                  required
                >
                  <option value="">Select Category</option>
                  <option value="winner 1">Winner</option>
                  <option value="winner 2">Runner-Up</option>
                  <option value="winner 3">Second Runner-Up</option>
                  <option value="participant">Participant</option>
                  <option value="finalist">Finalist</option>
                  <option value="training">Training</option>
                  <option value="advisor">Advisor</option>
                </select> */}
                <select
                  className="dropdownInputField"
                  value={cat}
                  onChange={handleCat}
                  required
                >
                  {dropdownOptions.map((category, index) => (
                    <option key={index} value={category.value}>
                      {category.label}
                    </option>
                  ))}
                  {subscriptionPlan === "pro" && (
                      <option value="custom">Custom Category</option>
                    )}
                </select>
                
                {cat === 'custom' && (
                  <SuiBox pt={1}>
                    <SuiInput
                      type="text"
                      className="customCategoryInput"
                      value={customCat}
                      onChange={handleInputChange}
                      placeholder="Enter custom category"
                      required
                    />
                  </SuiBox>    
                )}  
              </SuiBox>
              <SuiTypography component="label" variant="caption" fontWeight="bold">
                Font Size:
              </SuiTypography>
              {/* <SuiInput type="number" placeholder="0" onChange={(e) => setSize(e.target.value)} /> */}
              <SuiBox>
              <select
                  className="dropdownInputField"
                  value={size}
                  onChange={(e) => setSize(e.target.value)}
                >
                  {fontSizes.map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
              </SuiBox>
              <SuiTypography component="label" variant="caption" fontWeight="bold">
                  Serial No Font Size:
                </SuiTypography>
                {/* <SuiInput type="number" value={currentFontsize} placeholder="0" onChange={(e) => setCurrentFont(e.target.value)}/> */}
                <SuiBox>
                <select
                  className="dropdownInputField"
                  value={serialSize}
                  onChange={(e) => setSerialSize(e.target.value)}
                >
                  {serialFontSizes.map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
                </SuiBox>
              <SuiBox mt={3}>
                <SuiButton variant="gradient" color="dark" onClick={() => { createcertdetails() }}>Add Certificate</SuiButton>
              </SuiBox>
            </SuiBox>
          </Grid>
          <Grid item xs={12} lg={9}>
            <SuiBox p={2} pr={4} pl={10}>
              {pdfinfo ? (
                <SuiBox sx={{ position: 'relative', height: '100%' }}>
                  <iframe
                    src={`${pdfinfo}#toolbar=0&navpanes=0`}
                    ref={iframeRef}
                    style={{
                      width: `${pdfDimensions.width}px`,
                      height: `${pdfDimensions.height}px`,
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      overflow: "auto"
                    }}
                  />
                  <Draggable
                    position={{ x, y }}
                    bounds="parent"
                    onStop={handleStop}
                  >
                    <SuiBox
                      sx={{
                        position: 'absolute',
                        padding: `${size / 4}px`,
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        backgroundColor: 'white',
                        cursor: 'move',
                        userSelect: 'none',
                        top: 0,
                        left: 0,
                        transform: `translate(${x}px, ${y}px)`,
                        fontSize: `${size}px`
                      }}
                    >
                      <SuiTypography color={'rgba(0, 0, 0, 0.0)'} style={{ fontSize: `${size}px` }}>
                        [Sample Name]
                      </SuiTypography>
                    </SuiBox>
                  </Draggable>
                  <Draggable
                    position={{ x: serialX, y: serialY }}
                    bounds="parent"
                    onStop={(e, data) => { setSerialX(data.x); setSerialY(data.y); }}
                  >
                    <SuiBox
                      sx={{
                        position: 'absolute',
                        padding: `${serialSize / 4}px`,
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        backgroundColor: 'white',
                        cursor: 'move',
                        userSelect: 'none',
                        top: 0,
                        left: 0,
                        transform: `translate(${serialX}px, ${serialY}px)`,
                        fontSize: `${serialSize}px`
                      }}
                    >
                      <SuiTypography color={'rgba(0, 0, 0, 0.0)'} style={{ fontSize: `${serialSize}px` }}>
                        [Serial Number]
                      </SuiTypography>
                    </SuiBox>
                  </Draggable>
                </SuiBox>
              ) : (
                <SuiTypography variant="h5" color="textSecondary" textAlign="center" mt={2}>
                  No PDF uploaded yet.
                </SuiTypography>
              )}
            </SuiBox>
          </Grid>
        </Grid>
      </SuiBox>
      {/* <Footer /> */}
      <Modal open={isModalOpen} onClose={handleCloseModal} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <SuiBox my="auto" mx="auto"  p={1} bgColor={"white"} borderRadius="xl" display="flex">
        <SuiBox mt={1} mb={1} bgColor={"white"} borderRadius="xl">
          <Grid container>
          <Grid item xs={12} lg={3}>
              <SuiBox p={2} pr={4}>
                  <SuiBox mt={0} mb={0} >
                    <h4>Certificate Details</h4>
                  </SuiBox>
                  <SuiTypography component="label" variant="caption" fontWeight="bold">
                            Certificate Template
                      </SuiTypography>                         
                      <FileUploader className="file-uploader" value={currentFilename} handleChange={handleModalFileChange} types={['pdf']} />
                <SuiTypography component="label" variant="caption" fontWeight="bold">
                  Certificate Category
                 </SuiTypography>
                 <SuiBox>
                <select
                  className="dropdownInputField"
                  value={currentCat}
                  onChange={handleCurrentCat}
                  required
                >
                  {dropdownOptions.map((category, index) => (
                    <option key={index} value={category.value}>
                      {category.label}
                    </option>
                  ))}
                      <option value="custom">Custom Category</option>              
                </select>
                
                {currentCat === 'custom' && (
                  <SuiBox pt={1}>
                    <SuiInput
                      type="text"
                      className="customCategoryInput"
                      value={customCat}
                      onChange={handleInputChange}
                      placeholder="Enter custom category"
                      required
                    />
                  </SuiBox>    
                )}  
                 </SuiBox>
                    
                <SuiTypography component="label" variant="caption" fontWeight="bold">
                  Font Size:
                </SuiTypography>
                {/* <SuiInput type="number" value={currentFontsize} placeholder="0" onChange={(e) => setCurrentFont(e.target.value)}/> */}
                <SuiBox>
                <select
                  className="dropdownInputField"
                  value={currentFontsize}
                  onChange={(e) => setCurrentFont(e.target.value)}
                >
                  {fontSizes.map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
                </SuiBox>
                <SuiTypography component="label" variant="caption" fontWeight="bold">
                  Serial No Font Size:
                </SuiTypography>
                {/* <SuiInput type="number" value={currentFontsize} placeholder="0" onChange={(e) => setCurrentFont(e.target.value)}/> */}
                <SuiBox>
                <select
                  className="dropdownInputField"
                  value={currentSerialSize}
                  onChange={(e) => setCurrentSerialSize(e.target.value)}
                >
                  {serialFontSizes.map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
                </SuiBox>
                                 
                {/* <SuiTypography component="label" variant="caption" fontWeight="bold">
                  X:
                </SuiTypography>
                <SuiInput type="number" value={currentX} placeholder="0" /> 
                <SuiTypography component="label" variant="caption" fontWeight="bold">
                  Y:
                </SuiTypography>
                <SuiInput type="number" value={currentY} placeholder="0" />       
                <SuiTypography component="label" variant="caption" fontWeight="bold">
                  Font Color:
                </SuiTypography>
                <SuiInput type="color" onChange={(e) => {
                const color = e.target.value.match(/\w\w/g).map(x => parseInt(x, 16)/ 255);
                setR(color[0]);
                setG(color[1]);
                setB(color[2]);
              }}
              /> */}
                  <SuiBox mt={3}>
                    <SuiButton variant="gradient" color="dark" onClick={()=>{updateCertDetails(CurrentCertID)}}>Update Certificate</SuiButton>
                  </SuiBox>  
            </SuiBox>          
            </Grid>
            <Grid item xs={12} lg={9}>
              <SuiBox p={1} ml={10}>
                {Editpdfinfo ? (
                  <SuiBox sx={{ position: 'relative', height: '100%' }}>
                    <iframe
                      src={`${Editpdfinfo}#toolbar=0&navpanes=0`}
                      ref={iframeRefEdit}
                      style={{
                        width: `${editpdfDimensions.width}px`,
                        height: `${editpdfDimensions.height}px`,
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        overflow:"auto"
                      }}
                    />
                    <Draggable
                      position={{ x:currentX, y:currentY }}
                      bounds="parent"
                      onStop={handleStopModal}
                    >
                      <SuiBox
                        sx={{
                          position: 'absolute',
                          padding: `${size / 4}px`,
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                          backgroundColor: 'white',
                          cursor: 'move',
                          userSelect: 'none',
                          top: 0,
                          left: 0,
                          transform: `translate(${currentX}px, ${currentY}px)`,
                          fontSize: `${currentFontsize}px`
                        }}
                      >
                        <SuiTypography  color={'rgba(0, 0, 0, 0.0)'}style={{ fontSize: `${currentFontsize}px`}}>
                          [Sample Name]
                        </SuiTypography>
                      </SuiBox>
                    </Draggable>    
                    <Draggable
                    position={{ x: currentSerialX, y: currentSerialY }}
                    bounds="parent"
                    onStop={(e, data) => { setCurrentSerialX(data.x); setCurrentSerialY(data.y); }}
                  >
                    <SuiBox
                      sx={{
                        position: 'absolute',
                        padding: `${currentSerialSize / 4}px`,
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        backgroundColor: 'white',
                        cursor: 'move',
                        userSelect: 'none',
                        top: 0,
                        left: 0,
                        transform: `translate(${currentSerialX}px, ${currentSerialY}px)`,
                        fontSize: `${currentSerialSize}px`
                      }}
                    >
                      <SuiTypography color={'rgba(0, 0, 0, 0.0)'} style={{ fontSize: `${currentSerialSize}px` }}>
                        [Serial Number]
                      </SuiTypography>
                    </SuiBox>
                  </Draggable>                
                  </SuiBox>
                ) : (
                  <SuiTypography variant="h5" color="textSecondary" textAlign="center" mt={2}>
                    No PDF uploaded yet.
                  </SuiTypography>
                )}
              </SuiBox> 
            </Grid>         
          </Grid>
      </SuiBox> 
        </SuiBox>
      </Modal>
    </DashboardLayout>
  );
};

export default EditEventPage;
